<template>
  <div class="page-container">
    <div class="section-top">
      <div class="title-holder">
        <a href="/" class="link-back">
          <i class="icon icon-arrow-back"></i>
        </a>
        <h1 class="title">
          <span
            class="title-item"
            v-text="$ml.with('VueJS').get('personalTitle')"
          ></span>
        </h1>
      </div>
    </div>
    <div class="section-main user-page">
      <div class="user-info-holder">
        <div class="request-row">
          <span
            class="request-name"
            v-text="$ml.with('VueJS').get('labelFullName')"
            >ПІБ</span
          >
          <span class="request-val">{{ userName }}</span>
        </div>
        <div class="request-row">
          <span
            class="request-name"
            v-text="$ml.with('VueJS').get('labelEmail')"
            >E-mail</span
          >
          <span class="request-val">{{ userEmail }}</span>
        </div>
        <div class="request-row">
          <span
            class="request-name"
            v-text="$ml.with('VueJS').get('labelPhone')"
            >Телефон</span
          >
          <span class="request-val">{{ userPhone }}</span>
        </div>
        <div class="request-row">
          <span
            class="request-name"
            v-text="$ml.with('VueJS').get('labelRegion')"
            >Регіон</span
          >
          <span class="request-val">{{ userRegion }}</span>
        </div>
        <div class="request-row">
          <span
            class="request-name"
            v-text="$ml.with('VueJS').get('labelNumber')"
            >ЄДРПОУ</span
          >
          <span class="request-val">{{ userNumber }}</span>
        </div>
        <div class="request-row">
          <span
            class="request-name"
            v-text="$ml.with('VueJS').get('labelCompany')"
            >Назва підприємства</span
          >
          <span class="request-val">{{ userCompany }}</span>
        </div>
        <div class="user-action-holder">
          <div class="user-action-row">
            <a href="#/PersonalForm" class="link-red">
              <i class="icon icon-edit">icon</i>
              <span>{{ $ml.with("VueJS").get("personal1") }}</span>
            </a>
          </div>
          <div class="user-action-row dashed-border">
            <a href="#/PersonalPassword" class="link-red">
              <i class="icon icon-change-pass">icon</i>
              <span>{{ $ml.with("VueJS").get("personal2") }}</span>
            </a>
          </div>
          <p v-if="otherAccounts.length" class="other_accounts_container_title">
            Зв'язані підприємства
          </p>
          <div v-if="otherAccounts.length" class="dashed-border main_container">
            <div
              v-for="account in otherAccounts"
              :key="account.customer_id"
              class="other_accounts_container"
            >
              <div class="other_accounts_block1">
                <p class="other_account-title">ПІБ</p>
                <p class="other_account-text">{{ account.firstname || "-" }}</p>
              </div>
              <div class="other_accounts_block2">
                <p class="other_account-title">Назва підприємства</p>
                <p class="other_account-text">
                  {{ account.company_name || "-" }}
                </p>
              </div>
              <div class="other_accounts_block3">
                <p class="other_account-title">ЄДРПОУ</p>
                <p class="other_account-text">{{ account.okpo || "-" }}</p>
              </div>
              <div class="other_accounts_block4">
                <p class="other_account-title">Телефон</p>
                <p class="other_account-text">{{ account.telephone || "-" }}</p>
              </div>
              <div class="other_accounts_block5">
                <button
                  class="link-red"
                  @click="changeAccount(account.customer_id)"
                >
                  Увійти
                </button>
              </div>
            </div>
          </div>
          <div class="user-action-row exit-button">
            <a
              href="/#/Login"
              v-on:click="signOut()"
              class="link-red"
              v-text="$ml.with('VueJS').get('logout')"
              >{{ $ml.with("VueJS").get("personal3") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GET_USERS,
  LOG_LOGOUTS,
  GET_OTHER_ACCOUNTS,
  GET_CHANGE_ACCOUNT,
} from "../../helpers/requests";

export default {
  data() {
    return {
      resultUser: {},
      // title: 'Личный кабинет',
      otherAccounts: [],
      users: null,
      userId: localStorage.getItem("userId"),
      userName: localStorage.getItem("userName"),
      userPhone: localStorage.getItem("userPhone"),
      userEmail: localStorage.getItem("userEmail"),
      userRegion: localStorage.getItem("userRegion"),
      userNumber: localStorage.getItem("userNumber"),
      userCompany: localStorage.getItem("userCompany"),
      userToken: localStorage.getItem("userToken"),
    };
  },
  mounted() {
    this.loadJsonUser();
    this.loadOtherAccounts(this.userId, this.userToken);

    let profile = window.profile;

    if (profile) {
      this.userName = profile.userName;
      this.userPhone = profile.userPhone;
      this.userEmail = profile.userEmail;
      this.userRegion = profile.userRegion;
      this.userNumber = profile.userNumber;
      this.userCompany = profile.userCompany;
    }
    this.isLang(localStorage.activeItem);
  },
  methods: {
    async changeAccount(linked_customer_id) {
      let changedAccount;
      await GET_CHANGE_ACCOUNT(
        localStorage.userId,
        this.userToken,
        linked_customer_id
      )
        .then((response) => response.json())
        .then((response) => {
          changedAccount = response;
        });
      await GET_USERS(changedAccount.id)
        .then((response) => response.json())
        .then((response) => {
          this.$notify({
            type: "success",
            text: "Акаунт успішно змінено",
          });
          localStorage.setItem("userName", response.name);
          localStorage.setItem("userPhone", response.phone);
          localStorage.setItem("userEmail", response.email);
          localStorage.setItem("userRegion", response.region.name);
          localStorage.setItem("userNumber", response.egrpou);
          localStorage.setItem("userCompany", response.company_name);
          localStorage.setItem("userId", response.id);
          localStorage.setItem("userToken", changedAccount.token);
          document.cookie = "userToken=" + changedAccount.token;
          document.cookie = "userId=" + response.id;
          this.userName = response.name;
          this.userPhone = response.phone;
          this.userEmail = response.email;
          this.userRegion = response.region.name;
          this.userNumber = response.egrpou;
          this.userCompany = response.company_name;
          this.userToken = changedAccount.token;
          this.resultUser = response;
          this.loadOtherAccounts(response.id, changedAccount.token);
        });

      if (this.resultUser.can_use_app === false) {
        this.sendLogoutLogs({
          data: `Користувач ${localStorage.userName} з id ${
            localStorage.userId
          } не має доступу до додатку ${JSON.stringify(
            this.resultUser
          )} (Personal.139)`,
        });
        localStorage.clear();
        return;
      }
    },
    async loadOtherAccounts(id, token) {
      this.users = await GET_OTHER_ACCOUNTS(id, token)
        .then((response) => response.json())
        .then((response) => {
          this.resultUser = response;
        });
      this.otherAccounts = this.resultUser;
    },
    async loadJsonUser() {
      this.users = await GET_USERS(localStorage.userId)
        .then((response) => response.json())
        .then((response) => {
          this.resultUser = response;
        });
      if (
        typeof this.resultUser.can_use_app === "boolean" &&
        !this.resultUser.can_use_app
      ) {
        this.sendLogoutLogs({
          data: `Користувач ${localStorage.userName} з id ${
            localStorage.userId
          } не має доступу до додатку ${JSON.stringify(
            this.resultUser
          )} (Personal.139)`,
        });
        localStorage.clear();
        return;
      }
      this.userEmail = this.resultUser.email;
      this.userName = this.resultUser.name;
      this.userPhone = this.resultUser.phone;
      this.userRegion = this.resultUser.region.name;
      this.userNumber = this.resultUser.egrpou;
      this.userCompany = this.resultUser.company_name;
      this.saveLocalStorage(
        // this.resultUser.id,
        this.resultUser.name,
        this.resultUser.email,
        this.resultUser.phone,
        this.resultUser.region.name,
        this.resultUser.egrpou,
        this.resultUser.company_name
      );
      this.loading = false;
    },
    async sendLogoutLogs(errorMessage) {
      try {
        await LOG_LOGOUTS(JSON.stringify(errorMessage));
      } catch (error) {
        console.log(error.message);
      }
    },
    saveLocalStorage(
      userName,
      userEmail,
      userPhone,
      userRegion,
      userNumber,
      userCompany
    ) {
      // localStorage.setItem('userId', userId)
      localStorage.setItem("userName", userName);
      localStorage.setItem("userPhone", userPhone);
      localStorage.setItem("userEmail", userEmail);
      localStorage.setItem("userRegion", userRegion);
      localStorage.setItem("userNumber", userNumber);
      localStorage.setItem("userCompany", userCompany);
    },
    getLocalStorage() {
      // localStorage.getItem('userName')
    },
    signOut() {
      // this.deleteCookies()
      document.cookie = "userToken=;max-age=-1";
      localStorage.userToken = "";
      document.cookie = "userId=;max-age=-1";
      localStorage.userId = "";
    },
    // deleteCookies () {
    //   let cookies = document.cookie.split(';')
    //   for (let i = 0; i < cookies.length; i++) {
    //     let cookie = cookies[i]
    //     let eqPos = cookie.indexOf('=')
    //     let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    //     document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    //   }
    // }
    isLang: function (lang) {
      if (lang === "0") {
        this.$ml.change("ru");
      } else if (lang === "1") {
        this.$ml.change("ua");
      }
    },
  },
  async created() {},
  watch: {
    userName(newName) {
      localStorage.userName = newName;
    },
    userEmail(newEmail) {
      localStorage.userEmail = newEmail;
    },
    userPhone(newPhone) {
      localStorage.userPhone = newPhone;
    },
    userRegion(userRegion) {
      localStorage.userRegion = this.userRegion;
    },
    userNumber(userNumber) {
      localStorage.userNumber = userNumber;
    },
    userCompany(userCompany) {
      localStorage.userCompany = userCompany;
    },
  },
};
</script>

<style lang="scss" scoped>
.other_accounts_container_title {
  color: #000;
  font-weight: 600;
  margin-bottom: 10px;
}
.other_accounts_container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  border: 1px solid #e0e0e0;
}

.other_accounts_block1 {
  grid-area: 1 / 1 / 2 / 2;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.other_accounts_block2 {
  grid-area: 1 / 2 / 2 / 3;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
}
.other_accounts_block3 {
  grid-area: 2 / 1 / 3 / 2;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}
.other_accounts_block4 {
  grid-area: 2 / 2 / 3 / 3;
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
}
.other_accounts_block5 {
  display: flex;
  align-items: center;
  grid-area: 3 / 1 / 4 / 3;
  padding: 10px;

  .link-red {
    background: transparent;
    border: none;
    cursor: pointer;
  }
}
.other_account-title {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}
.other_account-text {
  font-size: 14px;
  color: #000;
  font-weight: 400;
}
.dashed-border {
  border-bottom: 1px dashed #e0e0e0;
  padding-bottom: 20px;
}
.exit-button {
  margin-top: 10px;
}
.main_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
